import { TrustBadge } from '@/components/ui/TrustBadge';

interface FormFooterProps {
  onBack: () => void;
  onNext: () => void;
  isFirstStep: boolean;
  isLastStep: boolean;
  isSubmitting: boolean;
  showFullDisclaimer?: boolean;
}

export default function FormFooter({
  onBack,
  onNext,
  isFirstStep,
  isLastStep,
  isSubmitting,
  showFullDisclaimer = false,
}: FormFooterProps) {
  return (
    <div className="mt-8 max-w-form mx-auto w-full">
      {/* Trust + disclaimers -- rendered above the sticky bar on mobile. */}
      <div className="hidden sm:block">
        {isLastStep && (
          <p className="mt-3 text-center text-xs leading-relaxed" style={{ color: 'var(--text-muted)' }}>
            By submitting, you agree to our{' '}
            <a href="https://onecalla.com/terms" target="_blank" rel="noopener noreferrer" className="underline">Terms of Service</a>
            {' '}and{' '}
            <a href="https://onecalla.com/privacy" target="_blank" rel="noopener noreferrer" className="underline">Privacy Policy</a>.
          </p>
        )}

        <div className="mt-6 flex justify-center">
          <TrustBadge />
        </div>

        {showFullDisclaimer ? (
          <p className="mt-4 text-center text-xs leading-relaxed max-w-md mx-auto" style={{ color: 'var(--text-muted)' }}>
            OneCalla does not sell insurance or act as a licensed agent or broker. We contact your existing carrier to identify available discounts on your current policy. No changes are made without your approval.
          </p>
        ) : null}

        <div className="mt-2 text-center text-xs" style={{ color: 'var(--text-muted)' }}>
          <a href="https://onecalla.com/privacy" target="_blank" rel="noopener noreferrer" className="hover:underline">Privacy Policy</a>
          <span className="mx-2">|</span>
          <a href="https://onecalla.com/terms" target="_blank" rel="noopener noreferrer" className="hover:underline">Terms of Service</a>
        </div>
      </div>

      {/* Sticky bottom bar on mobile; inline on >=640px. */}
      <div className="form-footer-bar">
        <div className="flex gap-3 items-center max-w-form mx-auto">
          {!isFirstStep ? (
            <button
              onClick={onBack}
              className="btn-back flex-shrink-0"
              disabled={isSubmitting}
              type="button"
            >
              Back
            </button>
          ) : (
            <div className="hidden sm:block" />
          )}

          <button
            onClick={onNext}
            className="btn-primary flex-1 sm:flex-none sm:w-auto"
            disabled={isSubmitting}
            type="button"
          >
            {isSubmitting
              ? 'Submitting...'
              : isLastStep
              ? 'Submit & Let Emery Take Over'
              : 'Continue'}
          </button>
        </div>

        {/* Mobile-only: compact last-step consent note inside the sticky bar's block. */}
        <div className="sm:hidden">
          {isLastStep && (
            <p className="mt-2 text-center text-[11px] leading-snug" style={{ color: 'var(--text-muted)' }}>
              By submitting, you agree to our{' '}
              <a href="https://onecalla.com/terms" target="_blank" rel="noopener noreferrer" className="underline">Terms</a>
              {' '}and{' '}
              <a href="https://onecalla.com/privacy" target="_blank" rel="noopener noreferrer" className="underline">Privacy Policy</a>.
            </p>
          )}
        </div>
      </div>

      {/* Mobile-only trust badge: in the flow above the sticky bar, not inside it. */}
      <div className="sm:hidden flex justify-center mt-6 mb-4">
        <TrustBadge />
      </div>
    </div>
  );
}
